/**
 * Return navigation for celebration fulfillment (checkout sheet,
 * product modal, pick-gift drawer) so buyers never lose Orders context.
 */

export interface FulfillmentReturnContext {
  label: string;
  onReturn: () => void;
}

/** Orders rail / needs-order checkout — dismiss overlays and restore list scroll. */
export function ordersFulfillmentReturn(onReturn: () => void): FulfillmentReturnContext {
  return {
    label: "Back to Orders",
    onReturn,
  };
}
